/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Aiflowaskentryfound4Inputs */

const en_aiflowaskentryfound4 = /** @type {(inputs: Aiflowaskentryfound4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I found ${i?.count} ticket types. How do guests get in?`)
};

const de_aiflowaskentryfound4 = /** @type {(inputs: Aiflowaskentryfound4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ich habe ${i?.count} Ticketarten gefunden. Wie kommen Gäste rein?`)
};

/**
* | output |
* | --- |
* | "I found {count} ticket types. How do guests get in?" |
*
* @param {Aiflowaskentryfound4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowaskentryfound4 = /** @type {((inputs: Aiflowaskentryfound4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowaskentryfound4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowaskentryfound4(inputs)
	return de_aiflowaskentryfound4(inputs)
});
export { aiflowaskentryfound4 as "aiFlowAskEntryFound" }